/* eslint-disable no-alert */
import React, { useState } from 'react';

import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import FakeModalLoading from 'src/components/functional/FakeModalLoading';

import Swal from 'sweetalert2';
import { IUserInfo } from '../../interfaces';
import { apiAuth } from '../../api';

import {
  Button,
  ContainerInputIcon,
  ContainerLabelInput,
  ContainerMain,
  ContainerReset,
  ContainerShieldText,
  FirstStrip,
  IconInput,
  IconShield,
  Input,
  LabelInput,
  LogoResolva,
  SubTitle,
  TextFirstStrip,
  TextShield,
  Title,
} from './style';

import logoResolva from '../../../../assets/images/reset-pass-icons/logo-resolva.svg';
import padlockIcon from '../../../../assets/images/reset-pass-icons/padlock-icon.svg';
import shieldIcon from '../../../../assets/images/reset-pass-icons/shield-icon.svg';
import mainIcon from '../../../../assets/images/reset-pass-icons/mail-icon.svg';

export default function ResetPass(): JSX.Element {
  const [userInfo, setUserInfo] = useState<IUserInfo>();
  const [disabled, setDisabled] = useState(false);

  const { token } = useParams();

  const urlBackApp = (): string => {
    if (/Android/i.test(navigator.userAgent)) {
      return process.env.REACT_APP_PACKAGE_ANDROID;
    }
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return process.env.REACT_APP_BUNDLE_ID_IOS;
    }
    return '';
  };

  const { isLoading } = useQuery(['getUserInfo', token], async () => apiAuth.getUserInfo(token), {
    onError: () => {
      void Swal.fire({
        icon: 'error',
        title: 'Tempo expirado!',
        text: 'Volte ao app e refaça o processo de redefinição de senha!',
        iconColor: 'black',
        allowOutsideClick: false,
        confirmButtonColor: 'black',
        confirmButtonText: `<a href=${urlBackApp()} style="color: white; text-decoration: none; fontWeight: 700; fontSize: 4.333vw;" >VOLTAR PARA O APP</a>`,
      });
      setDisabled(true);
    },
    onSuccess: (responseData) => {
      setUserInfo(responseData);
    },
    refetchOnWindowFocus: false,
  });

  const { isLoading: loadingMutation, mutate } = useMutation(
    async (userData: IUserInfo) => apiAuth.updatePassword(userData),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Tempo expirado!',
          text: 'Volte ao app e refaça o processo de redefinição de senha!',
          iconColor: 'black',
          allowOutsideClick: false,
          confirmButtonColor: 'black',
          confirmButtonText: `<a href=${urlBackApp()} style="color: white; text-decoration: none; fontWeight: 700; fontSize: 4.333vw;" >VOLTAR PARA O APP</a>`,
        });
      },
      onSuccess: (changedRows) => {
        if (changedRows !== 0) {
          void Swal.fire({
            icon: 'success',
            title: 'Senha atualizada com sucesso!',
            text: 'Volte ao app e faça login com sua nova senha!',
            iconColor: 'black',
            allowOutsideClick: false,
            confirmButtonColor: 'black',
            confirmButtonText: `<a href=${urlBackApp()} style="color: white; text-decoration: none; fontWeight: 700; fontSize: 4.333vw;" >VOLTAR PARA O APP</a>`,
          });
        }
      },
    }
  );

  const handleUpdatePassword = (): void => {
    setDisabled(true);
    if (userInfo.passConfirm !== userInfo.password || !userInfo.password) {
      alert('É preciso preencher os dois campos de senha e elas devem ser idênticas');
      setDisabled(false);
    } else if (userInfo.password.length < 6) {
      alert('A senha precisa ter pelo menos 6 dígitos');
      setDisabled(false);
    } else {
      mutate({ ...userInfo, token });
    }
  };

  const handleChange = ({ target: { name, value } }): void => {
    setUserInfo({ ...userInfo, [name]: value });
  };

  return (
    <ContainerMain>
      <FirstStrip>
        <TextFirstStrip>TODAS SUAS ROUPAS EM UM CLIQUE DA SUA MÃO</TextFirstStrip>
      </FirstStrip>
      <ContainerReset>
        <ContainerShieldText>
          <IconShield src={shieldIcon} alt="ícone de escudo" />
          <TextShield>Cadastro Seguro</TextShield>
        </ContainerShieldText>
        <LogoResolva src={logoResolva} alt="logo do resolva" />
        <Title>OLÁ {userInfo?.firstName.toUpperCase()}</Title>
        <SubTitle>
          Defina uma nova senha para o app do Resolva. Depois, pode voltar ao app e fazer login.
        </SubTitle>
        <ContainerLabelInput>
          <LabelInput>E-mail</LabelInput>
          <ContainerInputIcon>
            <Input
              type="email"
              placeholder="joanadarc@emailexemplo.com"
              disabled
              defaultValue={userInfo?.username.toLowerCase()}
            />
            <IconInput src={mainIcon} alt="ícone de email" />
          </ContainerInputIcon>
        </ContainerLabelInput>
        <ContainerLabelInput>
          <LabelInput>Nova senha</LabelInput>
          <ContainerInputIcon>
            <Input
              type="password"
              placeholder="**********"
              name="password"
              onChange={handleChange}
              disabled={disabled}
            />
            <IconInput src={padlockIcon} alt="ícone de email" />
          </ContainerInputIcon>
        </ContainerLabelInput>
        <ContainerLabelInput>
          <LabelInput>Confirme a nova senha</LabelInput>
          <ContainerInputIcon>
            <Input
              type="password"
              placeholder="**********"
              name="passConfirm"
              onChange={handleChange}
              disabled={disabled}
            />
            <IconInput src={padlockIcon} alt="ícone de email" />
          </ContainerInputIcon>
        </ContainerLabelInput>
        <Button onClick={handleUpdatePassword} disabled={disabled}>
          FINALIZAR
        </Button>
      </ContainerReset>
      {(isLoading || loadingMutation) && <FakeModalLoading />}
    </ContainerMain>
  );
}
